module.exports = __webpack_public_path__ + "static/media/construction1.c8b6c446.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/construction1.svg
// module id = 6193
// module chunks = 0